import httpService from "./http.service"

const companyService = {
  listCompanies: async (options = {}) => {
    const params = {}
    if (options.limit != null) params.limit = options.limit
    if (options.offset != null) params.offset = options.offset
    if (options.withTotal) params.with_total = 1
    if (options.qId) params.q_id = options.qId
    if (options.qName) params.q_name = options.qName
    if (options.qSlug) params.q_slug = options.qSlug
    if (options.qActive) params.q_active = options.qActive
    if (options.qOwner) params.q_owner = options.qOwner
    if (options.qCreated) params.q_created = options.qCreated
    if (options.createdFrom) params.created_from = options.createdFrom
    if (options.createdTo) params.created_to = options.createdTo
    if (options.sort) params.sort = options.sort
    if (options.sortDir) params.sort_dir = options.sortDir
    const { data } = await httpService.get("api/companies/", {
      params,
      signal: options.signal,
    })
    return data
  },
  getCompanyById: async (companyId, options = {}) => {
    const { data } = await httpService.get(`api/companies/id/${companyId}/`, {
      signal: options.signal,
    })
    return data
  },
  getCompanyBySlug: async (slug, options = {}) => {
    const { data } = await httpService.get(`api/companies/${slug}/`, {
      signal: options.signal,
    })
    return data
  },
  createCompany: async (payload) => {
    const { data } = await httpService.post("api/companies/", payload)
    return data
  },
  updateCompany: async (companyId, payload) => {
    const { data } = await httpService.patch(`api/companies/${companyId}/`, payload)
    return data
  },
  deleteCompany: async (companyId) => {
    const { data } = await httpService.delete(`api/companies/${companyId}/`)
    return data
  },
  setCompanyOwner: async (companyId, userId) => {
    const { data } = await httpService.patch(`api/companies/${companyId}/set-owner/`, {
      userId,
    })
    return data
  },
}

export default companyService
